import { CXF } from '@goodgamestudios/cxf-runtime'
import { AdBannerEvent, BigFarm } from '../../constants'
import log from '../../utils/logger'
import { GameEventTriggerType } from '../game-controller'

let cxf: CXF
let gameEventTrigger: GameEventTriggerType

function registerUpdatePay() {
  cxf.on('124', () => {}) // 124 - register the event handler for PAYMENT_DATA server command command
  cxf.on(BigFarm.UPDATE_PAY, (eventData: [object]) => {
    const [paymentData] = eventData
    gameEventTrigger(AdBannerEvent.UPDATE_PAY, paymentData)
  })
}

const registerCustomGameHandlers = (context: CXF, rootGameEventTrigger: GameEventTriggerType) => {
  log('BF - registerCustomGameHandlers')
  cxf = context
  gameEventTrigger = rootGameEventTrigger

  registerUpdatePay()
}

const bfController = {
  registerCustomGameHandlers,
}

export default bfController
